function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ReachMenu, ReachMenuList, ReachMenuButton } from "./menu-button-pieces";
import Icon from "./icon";
import ActionsMenuItem from "./actions-menu-item";

var ActionsMenu = function ActionsMenu(_ref) {
  var trigger = _ref.trigger,
      options = _ref.options,
      menuClassName = _ref.menuClassName,
      triggerClassName = _ref.triggerClassName,
      title = _ref.title,
      disabled = _ref.disabled;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      mounted_item = _useState2[0],
      setMountedItem = _useState2[1];

  var isGroupedOptions = options.length && options[0].items;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReachMenu, null, function (_ref2) {
    var isOpen = _ref2.isOpen;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReachMenuButton, {
      disabled: disabled,
      title: title,
      className: classNames({
        "et--actions-menu--trigger et--button-action": !trigger,
        "et--plain-button": trigger
      }, triggerClassName)
    }, typeof trigger === "function" ? trigger({
      isOpen: isOpen,
      disabled: disabled
    }) : /*#__PURE__*/React.createElement("span", null, "Actions...", /*#__PURE__*/React.createElement(Icon, {
      icon: isOpen ? "chevron-up" : "chevron-down"
    }))), /*#__PURE__*/React.createElement(ReachMenuList, {
      className: classNames("et--actions-menu--menu", menuClassName)
    }, options.map(function (option) {
      return isGroupedOptions ? /*#__PURE__*/React.createElement("div", {
        key: option.id,
        className: "et--actions-menu--option-group"
      }, option.heading && /*#__PURE__*/React.createElement("div", {
        className: "et--actions-menu--option-heading"
      }, option.heading), option.items.map(function (item) {
        return /*#__PURE__*/React.createElement(ActionsMenuItem, {
          key: item.id,
          option: item,
          setMountedItem: setMountedItem
        });
      })) : /*#__PURE__*/React.createElement(ActionsMenuItem, {
        key: option.id,
        option: option,
        setMountedItem: setMountedItem
      });
    })));
  }), mounted_item && mounted_item);
};

ActionsMenu.propTypes = {
  /**
   * An array of options with the following properties. Note id is important for the option key.
   * { id, title, icon, iconStyle, label, description, disabled, href, as, target, mountOnClick, onClick }
   */
  options: PropTypes.array.isRequired,

  /**
   * To a render prop for a trigger element other than the default action button. isOpen and disabled will be passed to this function
   */
  trigger: PropTypes.func,

  /**
   * Classname for trigger
   */
  triggerClassName: PropTypes.string,

  /**
   * Title for action button
   */
  title: PropTypes.string,

  /**
   * Classname for dropdown menu
   */
  menuClassName: PropTypes.string,

  /**
   * Disable action button
   */
  disabled: PropTypes.bool
};
export default ActionsMenu;